(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shipping-calculator"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('shippingCalculator', (variantId = null) => ({
      variantId: variantId,
      country: 'United States',
      province: '',
      query: '',
      open: false,
      zip: '',
      rates: null,
      loading: false,
      error: '',

      states: [
        { name: 'Alabama' },
        { name: 'Alaska' },
        { name: 'Arizona' },
        { name: 'Arkansas' },
        { name: 'California' },
        { name: 'Colorado' },
        { name: 'Connecticut' },
        { name: 'Delaware' },
        { name: 'Florida' },
        { name: 'Georgia' },
        { name: 'Hawaii' },
        { name: 'Idaho' },
        { name: 'Illinois' },
        { name: 'Indiana' },
        { name: 'Iowa' },
        { name: 'Kansas' },
        { name: 'Kentucky' },
        { name: 'Louisiana' },
        { name: 'Maine' },
        { name: 'Maryland' },
        { name: 'Massachusetts' },
        { name: 'Michigan' },
        { name: 'Minnesota' },
        { name: 'Mississippi' },
        { name: 'Missouri' },
        { name: 'Montana' },
        { name: 'Nebraska' },
        { name: 'Nevada' },
        { name: 'New Hampshire' },
        { name: 'New Jersey' },
        { name: 'New Mexico' },
        { name: 'New York' },
        { name: 'North Carolina' },
        { name: 'North Dakota' },
        { name: 'Ohio' },
        { name: 'Oklahoma' },
        { name: 'Oregon' },
        { name: 'Pennsylvania' },
        { name: 'Rhode Island' },
        { name: 'South Carolina' },
        { name: 'South Dakota' },
        { name: 'Tennessee' },
        { name: 'Texas' },
        { name: 'Utah' },
        { name: 'Vermont' },
        { name: 'Virginia' },
        { name: 'Washington' },
        { name: 'West Virginia' },
        { name: 'Wisconsin' },
        { name: 'Wyoming' },
        { name: 'District of Columbia' },
      ],

      get filteredStates() {
        const q = (this.query || '').toLowerCase();
        return this.states.filter((s) => s.name.toLowerCase().includes(q));
      },

      selectState(s) {
        this.province = s.name;
        this.query = s.name;
        this.open = false;
      },

      // Touch taps can be swallowed when the dropdown was scrolled, so fall back to
      // resolving the typed text against the state list before sending the request.
      resolveProvince() {
        if (this.province) return this.province;
        const q = (this.query || '').trim().toLowerCase();
        if (!q) return '';
        const exact = this.states.find((s) => s.name.toLowerCase() === q);
        if (exact) return exact.name;
        const matches = this.states.filter((s) => s.name.toLowerCase().startsWith(q));
        return matches.length === 1 ? matches[0].name : '';
      },

      get displayAddress() {
        return [this.zip, this.province, this.country].filter(Boolean).join(', ');
      },

      formatMoney(price) {
        const num = parseFloat(price);
        return '$' + num.toFixed(2);
      },

      buildQueryString() {
        const params = [
          'shipping_address[country]=' + encodeURIComponent(this.country),
          'shipping_address[zip]=' + encodeURIComponent(this.zip),
        ];
        if (this.province) {
          params.push('shipping_address[province]=' + encodeURIComponent(this.province));
        }
        return params.join('&');
      },

      get root() {
        return window.Shopify?.routes?.root || '/';
      },

      async getCart() {
        const res = await fetch(this.root + 'cart.js', {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });
        return res.json();
      },

      async postJson(path, body) {
        return fetch(this.root + path, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body),
        });
      },

      // shipping_rates.json only ever rates the current cart, so on a product page the
      // variant is added just long enough to be priced and then taken back out again.
      // The cart drawer is deliberately not refreshed, so the header count never moves.
      async withVariantInCart(run) {
        const cart = await this.getCart();
        const alreadyInCart = cart.items.some((item) => item.variant_id === Number(this.variantId));

        if (!this.variantId || alreadyInCart) {
          if (!cart.items.length) {
            this.error = 'Add this item to your cart to estimate freight.';
            return null;
          }
          return run();
        }

        const added = await this.postJson('cart/add.js', { id: Number(this.variantId), quantity: 1 });

        if (!added.ok) {
          // Sold out or otherwise unavailable: fall back to rating whatever is in the cart.
          if (cart.items.length) return run();
          this.error = await this.readError(added);
          return null;
        }

        try {
          return await run();
        } finally {
          await this.removeTemporaryLine();
        }
      },

      // Only pull the line back out if it is still the single unit that was just added.
      // If the shopper pressed "Add to cart" meanwhile, their quantity is left untouched.
      async removeTemporaryLine() {
        try {
          const cart = await this.getCart();
          const line = cart.items.find((item) => item.variant_id === Number(this.variantId));
          if (line && line.quantity === 1) {
            await this.postJson('cart/change.js', { id: line.key, quantity: 0 });
          }
        } catch (err) {
          console.error('[Shipping Calculator] could not restore cart:', err);
        }
      },

      // Shopify answers with 202 (and no body) while it is still asking the carriers
      // for rates, and expects the same URL to be re-requested until it answers 200.
      async requestRates(url) {
        const maxAttempts = 12;
        const pollDelay = 750;

        for (let attempt = 0; attempt < maxAttempts; attempt++) {
          const res = await fetch(url, {
            method: 'GET',
            cache: 'no-store',
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });

          if (res.status === 202) {
            await new Promise((resolve) => setTimeout(resolve, pollDelay));
            continue;
          }

          return res;
        }

        return null;
      },

      async readError(res) {
        let body = null;
        try {
          body = await res.json();
        } catch (err) {
          return 'Could not retrieve shipping rates.';
        }

        if (body && body.errors) {
          const messages = typeof body.errors === 'string' ? [body.errors] : Object.values(body.errors).flat();
          if (messages.length) return messages.join(' ');
        }

        return body?.message || body?.description || 'Could not retrieve shipping rates.';
      },

      async getRates() {
        if (!this.zip || this.loading) return;

        this.province = this.resolveProvince();
        if (!this.province) {
          this.error = 'Please pick your state from the list.';
          return;
        }
        this.query = this.province;

        this.loading = true;
        this.error = '';
        this.rates = null;

        try {
          const url = this.root + 'cart/shipping_rates.json?' + this.buildQueryString() + '&_ts=' + Date.now();

          await this.withVariantInCart(async () => {
            const res = await this.requestRates(url);

            if (!res) {
              this.error = 'Shipping rates are taking too long to calculate. Please try again.';
              return;
            }

            if (!res.ok) {
              const message = await this.readError(res);
              console.error('[Shipping Calculator] failed:', res.status, message);
              this.error = message;
              return;
            }

            const data = await res.json();
            this.rates = data.shipping_rates || [];
          });
        } catch (err) {
          console.error('[Shipping Calculator] Error:', err);
          this.error = err.message;
        } finally {
          this.loading = false;
        }
      },

      reset() {
        this.rates = null;
        this.province = '';
        this.query = '';
        this.zip = '';
        this.error = '';
      },
    }));
  });
  } catch(e) { console.error(e); }
})();

})();
